import { render, staticRenderFns } from "./JDAuthorization.vue?vue&type=template&id=0bbc47b0&scoped=true"
import script from "./JDAuthorization.vue?vue&type=script&lang=js"
export * from "./JDAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc47b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbc47b0')) {
      api.createRecord('0bbc47b0', component.options)
    } else {
      api.reload('0bbc47b0', component.options)
    }
    module.hot.accept("./JDAuthorization.vue?vue&type=template&id=0bbc47b0&scoped=true", function () {
      api.rerender('0bbc47b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/JDAuthorization.vue"
export default component.exports